"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _HBNewTable = require("./HBNewTable.types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBNewTableInfiniteScroll = function HBNewTableInfiniteScroll(_ref) {
  var Element = _ref.element,
    hasMore = _ref.hasMore,
    loadMore = _ref.loadMore,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? _HBNewTable.INFINITE_SCROLL_THRESHOLD : _ref$threshold,
    _ref$pageStart = _ref.pageStart,
    pageStart = _ref$pageStart === void 0 ? 1 : _ref$pageStart,
    loader = _ref.loader,
    children = _ref.children,
    columnCount = _ref.columnCount;
  var isFetchingRef = (0, _react.useRef)(false);
  var currentPageRef = (0, _react.useRef)(pageStart);
  var observer = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    observer.current = new IntersectionObserver(/*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(entries) {
        var firstEntry;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              firstEntry = entries[0];
              if (!(firstEntry.isIntersecting && hasMore && !isFetchingRef.current)) {
                _context.next = 7;
                break;
              }
              isFetchingRef.current = true;
              currentPageRef.current += 1;
              _context.next = 6;
              return loadMore(currentPageRef.current);
            case 6:
              isFetchingRef.current = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      rootMargin: "0px 0px ".concat(threshold, "px 0px")
    });
    var currentObserver = observer.current;
    var bottomRefCurrent = bottomRef.current;
    if (bottomRefCurrent && currentObserver) {
      currentObserver.observe(bottomRefCurrent);
    }
    return function () {
      if (bottomRefCurrent && currentObserver) {
        currentObserver.unobserve(bottomRefCurrent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMore, loadMore]);
  var bottomRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(Element, null, children, hasMore && /*#__PURE__*/_react["default"].createElement("td", {
    ref: bottomRef,
    colSpan: columnCount
  }, loader));
};
var _default = exports["default"] = HBNewTableInfiniteScroll;
//# sourceMappingURL=HBNewTableInfiniteScroll.js.map